import axios from "axios";
const graphqlUrl = process.env.VUE_APP_GRAPHQL_HTTP || 'https://livestock-api-gateway-dev.dimitra.dev/graphql'


var ActivityUrl = "animal/activity-log";
export default {
  async registerAnimal(data) {
    return await axios
      .post("/animal", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async uploadAnimals(data) {
    console.log(data)
    return await axios.post('animal/import', data)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },

  async getAnimals(type, dataOptions, search = "") {
    const { sortBy, sortDesc, page, itemsPerPage } = dataOptions;
    var url = `animal?page=${page}&limit=${itemsPerPage}&list=${type}`;
    if (search != "") url = `${url}&search=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },



  async getAnimalPerformance(animalId) {
    var url = `animal/performance/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async updateAnimalPerformance(animalData, alreadyRegistered) {
    var url = `animal/performance`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },

  async getAnimalSectionDate(section, animalId, tab = "", data, search = "") {
    const { sortBy, sortDesc, page, itemsPerPage } = data;
    var url = `animal/${section}/${animalId}`;
    if (tab.length) url = `${url}/${tab}`;
    url = `${url}?page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&search=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;

    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAllAnimalSectionData(section, tab = "", data) {
    const { sortBy, sortDesc, page, itemsPerPage } = data;
    var url = `animal/${section}`;
    if (tab.length) url = `${url}/${tab}`;
    url = `${url}?page=${page}&limit=${itemsPerPage}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;

    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async registerAnimalConception(animalData) {
    var url = `animal/conception`;

    return axios
      .post(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async searchSire(search) {
    var url = `option/animal/sire?limit=7&search=${search}`;
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAnimalHealthRecord(animalId) {
    var url = `animal/healthrecord/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalHealthRecord(animalData, alreadyRegistered) {
    var url = `animal/healthrecord`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },

  async getAnimalGenotypeData(animalId) {
    var url = `animal/genotype/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalGenotypeData(animalData, alreadyRegistered) {
    var url = `animal/genotype`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },

  async getAnimalGenworth(animalId) {
    var url = `animal/geneticworth/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalGenworth(animalData, alreadyRegistered) {
    var url = `animal/geneticworth`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },
  async getActivityLogs(dataOptions, animalNumber, search = "") {
    const { page, itemsPerPage } = dataOptions;
    var url = `${ActivityUrl}/${animalNumber}?page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&search=${search}`;

    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async getNotes(animalId) {
    var url = `animal/note/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async createNote(noteData) {
    return await axios
      .post("animal/note", noteData)
      .then(({ data }) => data)
      .catch((err) => err);
  },
  async updateAnimalImage(data) {
    return await axios
      .put("/animal/image", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async searchAnimal(search = "") {
    console.log(search)
    var url = "/option/animal/list?page=1&limit=1000";
    if (search.length > 0) url = `${url}&search=${search}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },

  async getFeedRecords(dataOptions, animalNumber, search = "") {
    const { page, itemsPerPage } = dataOptions;
    var url = `animal/feed?page=${page}&limit=${itemsPerPage}&animal=${animalNumber}`;
    if (search != "") url = `${url}&search=${search}`;

    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async registerFeed(data) {
    var url = `animal/feed`;
    return axios
      .post(url, data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getReminders(data, animalNumber, search = '') {
    const { page, itemsPerPage } = data;
    let url = `animal/reminder/${animalNumber}?page=${page}&limit=${itemsPerPage}`
    if (search != "") url = `${url}&search=${search}`;
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async animalGeneticsSearch(options, searchData) {
    try {
      const token = localStorage.getItem('token')
      let sarchData = [
        {
          "key": "bw",
          "value": {
            "min": searchData.bw.min && +searchData.bw.min, "max": searchData.bw.max && searchData.bw.max && +searchData.bw.max, "acc": searchData.bw.acc && +searchData.bw.acc
          }
        },
        {
          "key": "ww",
          "value": {
            "min": searchData.ww.min && +searchData.ww.min, "max": searchData.ww.max && +searchData.ww.max, "acc": searchData.ww.acc && +searchData.ww.acc
          }
        },
        {
          "key": "yw",
          "value": {
            "min": searchData.yw.min && +searchData.yw.min, "max": searchData.yw.max && +searchData.yw.max, "acc": searchData.yw.acc && +searchData.yw.acc
          }
        },
        {
          "key": "cw",
          "value": {
            "min": searchData.cw.min && +searchData.cw.min, "max": searchData.cw.max && +searchData.cw.max, "acc": searchData.cw.acc && +searchData.cw.acc
          }
        },
        {
          "key": "fat",
          "value": {
            "min": searchData.fat.min && +searchData.fat.min, "max": searchData.fat.max && +searchData.fat.max, "acc": searchData.fat.acc && +searchData.fat.acc
          }
        },
        {
          "key": "marb",
          "value": {
            "min": searchData.marb.min && +searchData.marb.min, "max": searchData.marb.max && +searchData.marb.max, "acc": searchData.marb.acc && +searchData.marb.acc
          }
        },
        {
          "key": "rea",
          "value": {
            "min": searchData.rea.min && +searchData.rea.min, "max": searchData.rea.max && +searchData.rea.max, "acc": searchData.rea.acc && +searchData.rea.acc
          }
        },
        {
          "key": "yg",
          "value": {
            "min": searchData.yg.min && +searchData.yg.min, "max": searchData.yg.max && +searchData.yg.max, "acc": searchData.yg.acc && +searchData.yg.acc
          }
        }

      ];

      const { page, itemsPerPage, sortBy, sortDesc } = options;

      const geneticSearchToolInput = {
        page: page,
        limit: itemsPerPage,
        gender: searchData.gender,
        breed: searchData.breed,
        searchData: sarchData,
        searchPhrase: "",
        sortCol: sortBy?.length > 0 && sortDesc?.length > 0 ? sortBy[0] : searchData.sortCol,
        sortOrder: sortBy?.length > 0 && sortDesc?.length > 0 ? sortDesc[0] ? 'DESC' : 'ASC' : searchData.sortOrder
      }

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query geneticSearchTool ($geneticSearchToolInput: GeneticSearchToolInput!){
            geneticSearchTool(geneticSearchToolInput: $geneticSearchToolInput){
                count,
                fetchedRows
                  rows{
                    id
                    animal_id
                    international_id
                    animalNumber
                    birth_weight
                  	registrationNumber
                  	name
                   	tagNumber
                    gender
                    tattoo
                    birthDate
                    birth_weight_epd
                    birth_weight_accuracy
                    weaning_weight_epd
                    weaning_weight_accuracy
                    yearling_weight_epd
                    yearling_weight_accuracy
                    ribEyeArea_epd
                    marbling_epd
                    fatThickness_epd
                    carcass_weight_epd
                    yield_grade_epd
                    status
                    createdAt
                    birth_weight_rank,
                    weaning_weight_rank,
                    yearling_weight_rank,
                    fatThickness_rank,
                    ribEyeArea_rank,
                    marbling_rank,
                    carcass_weight_rank,
                    yield_grade_rank,
                }
            }
          }`,
          variables: {
            geneticSearchToolInput: geneticSearchToolInput
          }

        }
      });

      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },

  async animalGeneticsSearchByReg(options, searchData) {
    try {
      const token = localStorage.getItem('token')

      const { page, itemsPerPage, } = options;

      const geneticSearchToolInput = {
        page: page,
        limit: itemsPerPage,
        gender: searchData.gender,
        searchCol: searchData.searchCol,
        search: searchData.search,
      }

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query geneticSearchToolById ($geneticSearchToolInput: GeneticSearchToolByIdInput!){
            geneticSearchToolById(geneticSearchToolInput: $geneticSearchToolInput){
                count,
                fetchedRows
                  rows{
                  	id
                    animal_id
                    international_id
                    animalNumber
                    birth_weight
                  	registrationNumber
                  	name
                   	tagNumber
                    gender
                    tattoo
                    birthDate
                    birth_weight_epd
                    birth_weight_accuracy
                    weaning_weight_epd
                    weaning_weight_accuracy
                    yearling_weight_epd
                    yearling_weight_accuracy
                    ribEyeArea_epd
                    marbling_epd
                    fatThickness_epd
                    carcass_weight_epd
                    yield_grade_epd
                    status
                    createdAt
                    birth_weight_rank,
                    weaning_weight_rank,
                    yearling_weight_rank,
                    fatThickness_rank,
                    ribEyeArea_rank,
                    marbling_rank,
                    carcass_weight_rank,
                    yield_grade_rank,
                    milk_ability_epd,
                    milk_ability_accuracy,
                    milk_ability_rank,
                }
            }
          }`,
          variables: {
            geneticSearchToolInput: geneticSearchToolInput
          }

        }
      });
      console.log(result)
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },
  async singleAnimalDetail(animalNumber) {
    try {
      const token = localStorage.getItem('token')

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query getByAnimalNumber ( $animalNumber: String!){
            getByAnimalNumber(animalNumber: $animalNumber){
                    id
                    animalNumber
                    birth_weight
                    gender
                    animal_id
                    international_id
                    breed
                    color
                    owner
                    horn
                    owner
                    breeder_code
                    sire_id,
                    dam_id
                    conceptionMethod
                    birthDate
                    registrationNumber
                    registrationDate
                    tattoo
                    name
                   	tagNumber
            }
          }`,
          variables: {
            animalNumber: animalNumber
          }

        }
      });
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },
  async getSingleEpdInfo(epdId) {
    try {
      const token = localStorage.getItem('token')

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query animalDetail ( $epdId: Int!){
            animalDetail(epdId: $epdId){
                animalEpd{
       							id   
                    yearling_height        
                    weaning_date
                    weaning_weight
                    yearling_date
                    yearling_weight
                    adjusted_birth_weight
                    adjusted_weaning_weight
                    adjusted_yearling_weight
                    average_birth_weight
                    average_weaning_weight
                    average_yearling_weight
                    birth_weight_epd
                    weaning_weight_epd
                    yearling_weight_epd
                    birth_weight_kg
                    weaning_weight_kg
                    yearling_weight_kg
                    accuracyWeight_for_field
                    ribEyeArea
                    fatThickness
                    marbling
                    marbling_epd
                    ribEyeArea_epd
                    fatThickness_epd
                    carcass_weight
                    kph_fat
                    yield_grade
                    yield_grade_epd
                    carcass_weight_epd
                    weaning_sex
                    yearling_sex
                    marbling_unit
                    kph_fat_unit
                    fat_thickness_unit
                    rib_eye_area_unit
                    yearling_management_code
                    birth_weight_cg_id
                    weaning_weight_cg_id
                    yearling_weight_cg_id
                    carcass_contemporary_group_id
                    birth_weight_epd,
            },
            sireEpd{
       							id   
                    yearling_height        
                    weaning_date
                    weaning_weight
                    yearling_date
                    yearling_weight
                    adjusted_birth_weight
                    adjusted_weaning_weight
                    adjusted_yearling_weight
                    average_birth_weight
                    average_weaning_weight
                    average_yearling_weight
                    birth_weight_epd
                    weaning_weight_epd
                    yearling_weight_epd
                    birth_weight_kg
                    weaning_weight_kg
                    yearling_weight_kg
                    accuracyWeight_for_field
                    ribEyeArea
                    fatThickness
                    marbling
                    marbling_epd
                    ribEyeArea_epd
                    fatThickness_epd
                    carcass_weight
                    kph_fat
                    yield_grade
                    yield_grade_epd
                    carcass_weight_epd
                    weaning_sex
                    yearling_sex
                    marbling_unit
                    kph_fat_unit
                    fat_thickness_unit
                    rib_eye_area_unit
                    yearling_management_code
                    birth_weight_cg_id
                    weaning_weight_cg_id
                    yearling_weight_cg_id
                    carcass_contemporary_group_id
                    birth_weight_epd,
                  }
            damEPd{
       							id   
                    yearling_height        
                    weaning_date
                    weaning_weight
                    yearling_date
                    yearling_weight
                    adjusted_birth_weight
                    adjusted_weaning_weight
                    adjusted_yearling_weight
                    average_birth_weight
                    average_weaning_weight
                    average_yearling_weight
                    birth_weight_epd
                    weaning_weight_epd
                    yearling_weight_epd
                    birth_weight_kg
                    weaning_weight_kg
                    yearling_weight_kg
                    accuracyWeight_for_field
                    ribEyeArea
                    fatThickness
                    marbling
                    marbling_epd
                    ribEyeArea_epd
                    fatThickness_epd
                    carcass_weight
                    kph_fat
                    yield_grade
                    yield_grade_epd
                    carcass_weight_epd
                    weaning_sex
                    yearling_sex
                    marbling_unit
                    kph_fat_unit
                    fat_thickness_unit
                    rib_eye_area_unit
                    yearling_management_code
                    birth_weight_cg_id
                    weaning_weight_cg_id
                    yearling_weight_cg_id
                    carcass_contemporary_group_id
                    birth_weight_epd,
                }
            }
          }`,
          variables: {
            epdId: +epdId
          }

        }
      });
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },
  async getOwnership(epdId) {
    try {
      const token = localStorage.getItem('token')

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query getOwnership ( $epdId: Int!){
            getOwnership(epdId: $epdId){
              ownerName,
                  ranch,
                  dateOwned,
                  percentOwnership,
                  user{
                    name,
                    email,
                    mobile
                  }
            }
          }`,
          variables: {
            epdId: +epdId
          }

        }
      });
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },
  async getPerformance(epdId) {
    try {
      const token = localStorage.getItem('token')

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query getPerformance ( $epdId: Int!){
            getPerformance(epdId: $epdId){
              birthDate
              weaning_date
              yearling_date
              weightUnit
              scrotal_circumference
              birth_weight
              weaning_weight
              yearling_weight
              birth_weight_cg
              weaning_weight_cg
              yearling_weight_cg
              adjusted_birth_weight
              adjusted_weaning_weight
              adjusted_yearling_weight     
            }
          }`,
          variables: {
            epdId: +epdId
          }

        }
      });
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },
  async getProgeny(epdId) {
    try {
      const token = localStorage.getItem('token')

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query getProgeny ( $epdId: Int!){
            getProgeny(epdId: $epdId){
              year,
              animals{
                id,
                gender
                animalNumber
                registrationNumber
                name
                status
                birthDate
                age
                isDied
                year
              }
              count 
            }
          }`,
          variables: {
            epdId: +epdId
          }

        }
      });
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },
  async getAnimalPedigree(epdId) {
    try {
      const token = localStorage.getItem('token')

      const result = await axios({
        url: graphqlUrl,
        headers: {
          authorization: token
        },
        method: 'post',
        data: {
          query: `
          query getPedigree ( $epdId: Int!){
            getPedigree(epdId: $epdId){
                  id
              sires {
                animalNumber
                name
                sirePubId
                damPubId
                sires {
                  animalNumber
                  name
                  sirePubId
                  damPubId
                  sires {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                  dams {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                }
                dams {
                  animalNumber
                  name
                  sirePubId
                  damPubId
                  sires {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                  dams {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                }
              }
              dams {
                animalNumber
                name
                sirePubId
                damPubId
                sires {
                  animalNumber
                  name
                  sirePubId
                  damPubId
                  sires {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                  dams {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                }
                dams {
                  animalNumber
                  name
                  sirePubId
                  damPubId
                  sires {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                  dams {
                    animalNumber
                    name
                    sirePubId
                    damPubId
                    sires {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                    dams {
                      animalNumber
                      name
                      sirePubId
                      damPubId
                      sires {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                      dams {
                        animalNumber
                        name
                        sirePubId
                        damPubId
                      }
                    }
                  }
                }
              }
            }
          }`,
          variables: {
            epdId: +epdId
          }

        }
      });
      return result.data
    } catch (err) {
      console.log(err)
      return {};
    }
  },


  async getSingleAnimal(animalId) {
    var url = `animal/detailById/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimal(animalData) {
    var url = `animal`;
    return axios
      .put(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },



  //from lgcloud
  //http://localhost:3020/apihttp://localhost:3020/api

  async getSingleAnimalById(animalId) {
    var url = `http://localhost:3020/api/animal/detailById/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalById(animalData) {
    var url = `http://localhost:3020/api/animal/updateFromEpd`;
    return axios
      .put(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },


  async getAnimalWithGender(gender, data, search = "", currentAnimal = null) {
    const { page, itemsPerPage } = data
    let url = `http://localhost:3020/api/animal/animalswithgender/${gender}?search=${search}&page=${page}&itemsPerPage=${itemsPerPage}`
    if (currentAnimal)
      url = `${url}&currentAnimal=${currentAnimal}`
    return axios
      .get(url)
      .then(res => res.data)
      .then(data => Promise.resolve(data))
      .catch(err => Promise.reject(err))
  }

};
